import {
  STATUS_ARCHIVED,
  STATUS_DEACTIVATED,
  STATUS_REDIRECTED,
  STATUS_NEVER_PUBLISHED,
  STATUS_NO_LINKS,
  STATUS_ACTIVE,
  STATUS_NO_CLONEABLE_VERSION,
  STATUS_UP_TO_DATE
} from 'site_status.js';

export function getPageStatus({ page, pageLinks }) {
  var status, description;
  const hasLinks = pageLinks.length > 0;

  if (page.isArchived()) {
    status = STATUS_ARCHIVED;
    description = `This site has been archived. It is inaccessible and uneditable until 
      it is unarchived.`;

  } else if (page.isRedirected()) {
    status = STATUS_REDIRECTED;
    description = `This site has been redirected. It is inaccessible because
      all links pointing at it are being redirected to another site.`;

  } else if (page.isDeactivated()) {
    status = STATUS_DEACTIVATED;
    description = `This site has been deactivated. It is inaccessible because
      all links pointing at it will result in a "not found (404)" message
      until it is reactivated.`;
    
  } else if (page.isNeverPublished()) {
    status = STATUS_NEVER_PUBLISHED;
    description = `This site has never been published. It is inaccessible until
      it is published at least once. Open the site in the editor to publish it.`;

  } else if (!hasLinks) {
    status = STATUS_NO_LINKS;
    description = `This site has no links associated with it. It is inaccessible
      until at least one link is added.`;

  } else {
    status = STATUS_ACTIVE;
    description = 'This site is accessible.';

  }

  return {
    status,
    description
  };
}


export function getTemplateStatus({ template }) {
  let status;
  let description;

  if (template.isArchived()) {
    status = STATUS_ARCHIVED;
    description = 'This template has been archived. It is uneditable until it is unarchived.';
    
  } else if (template.isNeverPublished()) {
    status = STATUS_NO_CLONEABLE_VERSION;
    description = 'This template has no cloneable version. Pages cannot be created from it until one is created. Open the template in the editor and click "Update Version".';
  
  } else if (!template.hasUnpublishedChanges()) {
    status = STATUS_UP_TO_DATE;
    description = 'This template has no drafted changes.';
  
  } 

  return {
    status,
    description
  };
}
